import { useContext } from "react";
import { ChimeMeetingContext } from "../providers";

const useChimeMeeting = () => {
  const chimeMeetingContext = useContext(ChimeMeetingContext);

  if (!chimeMeetingContext) {
    throw new Error(
      "useChimeMeeting must be used within an ChimeMeetingProvider",
    );
  }
  return chimeMeetingContext;
};

export default useChimeMeeting;
